export default __webpack_public_path__ + "static/banner-38f3221507f86358d5d2a4a32bbdd7b9.jpg";